<template>
  <div class="baseView">
    <!--pdf-->
    <iframe v-if="fileType==='pdf'" :src="fileUrl" frameborder="0"
            style="width: 100%;height: 98vh;"></iframe>
    <!--视频-->
    <video v-if="fileType==='mp4'" :src="fileUrl" autoplay controls muted style="width: 100%;height: 98vh;"></video>
    <!--文档-->
    <iframe v-if="fileType==='docx'||fileType==='doc'||fileType==='xlsx'||fileType==='xls'"
            :src="'https://view.officeapps.live.com/op/view.aspx?src='+encodeURIComponent(fileUrl)"
            frameborder="0"
            style="width: 100%;height: 98vh;"></iframe>
    <!--图片-->
    <img v-if="fileType==='png'||fileType==='jpg'||fileType==='jpeg'" :src="fileUrl" alt=""
         style="width: 80%;margin-left: 10%">
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {onMounted, reactive, ref} from "vue"
import {useRouter} from "vue-router/dist/vue-router";

let router = useRouter()
let fileType = ref()
let fileUrl = ref()

onMounted(() => {
  fileUrl.value = router.currentRoute.value.query.url
  let url = router.currentRoute.value.query.url.split('.')
  fileType.value = url[url.length - 1]
})

</script>

<style lang="less" scoped>
.baseView {

}
</style>
